import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "pre-installed-packages"
    }}>{`Pre-installed packages`}</h1>
    <p>{`These are the packages that are pre-installed and available to any I/O Runtime user:`}</p>
    <pre><code parentName="pre" {...{}}>{`/whisk.system/alarms                                                  
`}</code></pre>
    <p>{`You can get details about the content of a package by running this command:`}</p>
    <pre><code parentName="pre" {...{}}>{`aio rt:package:get /whisk.system/alarms
`}</code></pre>
    <p>{`You can execute any of the actions defined in a shared package by using the fully qualified name. For example:`}</p>
    <pre><code parentName="pre" {...{}}>{`aio rt:action:invoke /whisk.system/alarms/alarm
`}</code></pre>
    <p>{`Alternatively, you can bind any of this packages to your namespace; see the `}<a parentName="p" {...{
        "href": "../reference/packages.md"
      }}>{`Packages page`}</a>{`. When you bind a package, you can set your own default parameters (if there are any parameters) and run the actions as being local to your namespace.`}</p>
    <h2 {...{
      "id": "using-the-alarms-package"
    }}>{`Using the alarms package`}</h2>
    <p>{`The alarms package can be used to trigger an action(s) for a given interval (once or recurring).This is a three-step process:`}</p>
    <ol>
      <li parentName="ol">{`Create one or more actions you want to be executed. There is nothing special about these actions, you`}{`’`}{`d create them just as you would any other action.`}</li>
      <li parentName="ol">{`Create a trigger and specify the frequency. This is what the Alarms package provides.`}</li>
      <li parentName="ol">{`Create a rule that links the action(s) to the trigger Every time the trigger is fired, the action(s) is executed.`}</li>
    </ol>
    <p>{`The alarms package contains:`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Entity`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Parameters`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`/whisk.system/alarms`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`package`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`-`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Alarms utility`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`/whisk.system/alarms/interval`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`feed`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`minutes`}</inlineCode>{`, `}<inlineCode parentName="td">{`trigger_payload`}</inlineCode>{`, `}<inlineCode parentName="td">{`startDate`}</inlineCode>{`, `}<inlineCode parentName="td">{`stopDate`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Fire Trigger event on an interval-based schedule`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`/whisk.system/alarms/once`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`feed`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`date`}</inlineCode>{`, `}<inlineCode parentName="td">{`trigger_payload`}</inlineCode>{`, `}<inlineCode parentName="td">{`deleteAfterFire`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Fire Trigger event once on a specific date`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`/whisk.system/alarms/alarm`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`feed`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`cron`}</inlineCode>{`, `}<inlineCode parentName="td">{`trigger_payload`}</inlineCode>{`, `}<inlineCode parentName="td">{`startDate`}</inlineCode>{`, `}<inlineCode parentName="td">{`stopDate`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Fire Trigger event on a time-based schedule using cron`}</td>
        </tr>
      </tbody>
    </table>
    <p>{`To create a trigger on an interval-based schedule that will fire every 10 minutes until January 31, 2020 (`}<inlineCode parentName="p">{`my-interval`}</inlineCode>{` is the name of the trigger):`}</p>
    <pre><code parentName="pre" {...{}}>{`aio rt:trigger:create my-interval \\
  --feed /whisk.system/alarms/interval \\
  --param minutes 10 \\
  --param trigger_payload "{\\"name\\":\\"Vlad\\",\\"place\\":\\"Transylvania\\"}" \\
  --param stopDate "2020-01-31T23:59:00.000Z"
`}</code></pre>
    <p>{`To create a trigger that fires once:`}</p>
    <pre><code parentName="pre" {...{}}>{`aio rt:trigger:create my-interval \\
  --feed /whisk.system/alarms/once \\
  --param trigger_payload "{\\"name\\":\\"Vlad\\",\\"place\\":\\"Transylvania\\"}" \\
  --param stopDate "2020-01-31T23:59:00.000Z"
  --param deleteAfterFire "rules"
`}</code></pre>
    <p>{`Finally, to create a trigger that fires on a time-based schedule using cron (it fires every hour):`}</p>
    <pre><code parentName="pre" {...{}}>{`aio rt:trigger:create my-interval \\
  --feed /whisk.system/alarms/alarm \\
  --param cron "0 * * * *" \\
  --param trigger_payload "{\\"name\\":\\"Vlad\\",\\"place\\":\\"Transylvania\\"}" \\
  --param startDate "2018-10-17" \\
  --param stopDate "2019-10-31T23:59:00.000Z"
`}</code></pre>
    <p>{`Here are some examples of how to set various `}<inlineCode parentName="p">{`cron`}</inlineCode>{` values - for more info check this `}<a parentName="p" {...{
        "href": "http://crontab.org"
      }}>{`page`}</a>{`:`}</p>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`* * * * *`}</inlineCode>{`: The Trigger fires at the top of every minute.`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`0 * * * *`}</inlineCode>{`: The Trigger fires at the top of every hour.`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`0 */2 * * *`}</inlineCode>{`: The Trigger fires every 2 hours (that is, 02:00:00, 04:00:00, ...).`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`0 9 8 * *`}</inlineCode>{`: The Trigger fires at 9:00:00AM (UTC) on the eighth day of every month.`}</li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      